(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-button-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("a.custom-button-container").forEach(function (button) {
    button.addEventListener("click", function (event) {
      const href = button.getAttribute("href");

      if (!href || !href.startsWith("#")) return;

      event.preventDefault();

      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
